import { AfterViewInit, Component } from '@angular/core';
import * as L from 'leaflet';
import { ActivatedRoute } from "@angular/router"
import { StopsService } from '../../services/stops.service';


@Component({
  selector: 'app-embedded-map-single',
  templateUrl: './embedded-map-single.component.html',
  styleUrls: ['./embedded-map-single.component.css']
})
export class EmbeddedMapSingleComponent implements AfterViewInit {
  public map: any;
  public current_position: any = null;

  public mode: string = '';
  public stop: string = '';
  public id: string = '';
  public data: any;

  constructor(private route: ActivatedRoute, private stopsService: StopsService) {
    this.mode = this.route.snapshot.paramMap.get('mode');
    this.stop = this.route.snapshot.paramMap.get('stop');
    this.id = this.route.snapshot.paramMap.get('route');

    this.stopsService.get(this.mode, this.id)
    .subscribe(data => this.data = data);
  }

  ngAfterViewInit(): void {
    this.stopsService.get(this.mode, this.id)
    .subscribe(data => {this.data = data; this.initMap()})
    if(this.map != null){
      this.map.off();
      this.map.remove();
    }

  }

  private initMap(): void {
    console.log(this.data);
    const lat = this.data[0]["stop_lat"];
    const lon = this.data[0]["stop_lon"];
    const name = this.data[0]["stop_name"];

    this.map = L.map('map', {
      fullscreenControl: true,
      fullscreenControlOptions: {
        position: 'topleft'
      },
      center: [lat, lon],
      zoom: 13
    });

    this.stopsService.get(this.mode, this.id)
    .subscribe(data => this.data = data);

    L.marker([lat, lon]).addTo(this.map)
    .bindPopup(name)
    .openPopup();

    const tiles = L.tileLayer('https://tiles.septa.org/tiles/raster/{z}/{x}/{y}.png',
      {
        maxZoom: 17,
        minZoom: 9,
        attribution:
        '&copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/about/">OpenStreetMap contributors</a>'
      }
    );

    tiles.addTo(this.map);
  }
}
